export const NO_TEAM = {
  TEAMS_NOT_AVAILABLE_DESC: {
    key: 'TEAMS_NOT_AVAILABLE_DESC',
    value: "You are not in part of any team, So you can't create a {{type}}!",
  },
};